/** Phase 20 */
import { listAggregatePersistentStockData } from '../infrastructure/storage/domainAggregateStore';
import { listEntityPersistentStockData } from '../infrastructure/storage/entityAggregateStore';
import { createArrayEntityReadSource } from './arrayEntityReadSourceFactory';

const source = createArrayEntityReadSource({
  field: 'persistentStockData',
  listAggregate: listAggregatePersistentStockData,
  listEntity: listEntityPersistentStockData,
  idKeys: ['id', 'productId', 'locationId']
});

export const readPersistentStockDataFromMergedBlob = source.readFromMergedBlob;
export const readPersistentStockDataFromBestSource = source.readFromBestSource;
export const refreshPersistentStockDataReadCache = source.refreshReadCache;
export const getCachedPersistentStockDataRead = source.getCachedRead;
export const clearPersistentStockDataReadCache = source.clearReadCache;
export const readPersistentStockDataSyncForBusiness = source.readSyncForBusiness;
